// extracted by mini-css-extract-plugin
export default {"footer":"Footer-footer-2nh"};